<!--<template>-->
<!--    <span class="search-btn" @click="toggle">-->
<!--        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path d="M10.7297 0.00280762C4.90209 0.00280762 0.160645 4.74426 0.160645 10.5719C0.160645 16.3999 4.90209 21.141 10.7297 21.141C16.5577 21.141 21.2988 16.3999 21.2988 10.5719C21.2988 4.74426 16.5577 0.00280762 10.7297 0.00280762ZM10.7297 19.1898C5.97787 19.1898 2.11186 15.3238 2.11186 10.5719C2.11186 5.82009 5.97787 1.95402 10.7297 1.95402C15.4816 1.95402 19.3476 5.82004 19.3476 10.5719C19.3476 15.3237 15.4816 19.1898 10.7297 19.1898Z" fill="white"/>-->
<!--            <path d="M23.8751 22.3374L18.2816 16.7439C17.9005 16.3627 17.2832 16.3627 16.9021 16.7439C16.5209 17.1247 16.5209 17.7426 16.9021 18.1234L22.4956 23.7169C22.6861 23.9074 22.9356 24.0027 23.1853 24.0027C23.4347 24.0027 23.6845 23.9074 23.8751 23.7169C24.2562 23.3361 24.2562 22.7182 23.8751 22.3374Z" fill="white"/>-->
<!--        </svg>-->
<!--    </span>-->

<!--    <teleport to="#search-field">-->
<!--        <transition name="fade">-->
<!--            <div v-if="isOpen" class="search-modal__wrapper">-->
<!--                <div class="search-modal">-->
<!--                    <input ref="searchInput" type="text" v-model="text" @input="onTextChanged" @keypress.enter="onSearch" aria-label="תוצאות חיפוש">-->
<!--                    <div class="search-modal__close" @click="toggle">-->
<!--                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none"-->
<!--                             xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M11.9375 9.99995L19.7943 2.21211C20.3056 1.70554 20.3056 0.886492 19.7943 0.379925C19.2833 -0.126642 18.4569 -0.126642 17.9459 0.379925L10.0888 8.16777L2.23195 0.379925C1.72064 -0.126642 0.894552 -0.126642 0.383482 0.379925C-0.127827 0.886492 -0.127827 1.70554 0.383482 2.21211L8.24031 9.99995L0.383482 17.7878C-0.127827 18.2944 -0.127827 19.1134 0.383482 19.62C0.638179 19.8727 0.973067 19.9996 1.30772 19.9996C1.64237 19.9996 1.97701 19.8727 2.23195 19.62L10.0888 11.8321L17.9459 19.62C18.2008 19.8727 18.5354 19.9996 18.8701 19.9996C19.2047 19.9996 19.5394 19.8727 19.7943 19.62C20.3056 19.1134 20.3056 18.2944 19.7943 17.7878L11.9375 9.99995Z"-->
<!--                                  fill="#FFFFFF"/>-->
<!--                        </svg>-->
<!--                    </div>-->
<!--                    <div class="search-modal__btn" @click="onSearch">-->
<!--                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                            <path d="M10.7297 0.00280762C4.90209 0.00280762 0.160645 4.74426 0.160645 10.5719C0.160645 16.3999 4.90209 21.141 10.7297 21.141C16.5577 21.141 21.2988 16.3999 21.2988 10.5719C21.2988 4.74426 16.5577 0.00280762 10.7297 0.00280762ZM10.7297 19.1898C5.97787 19.1898 2.11186 15.3238 2.11186 10.5719C2.11186 5.82009 5.97787 1.95402 10.7297 1.95402C15.4816 1.95402 19.3476 5.82004 19.3476 10.5719C19.3476 15.3237 15.4816 19.1898 10.7297 19.1898Z" fill="white"/>-->
<!--                            <path d="M23.8751 22.3374L18.2816 16.7439C17.9005 16.3627 17.2832 16.3627 16.9021 16.7439C16.5209 17.1247 16.5209 17.7426 16.9021 18.1234L22.4956 23.7169C22.6861 23.9074 22.9356 24.0027 23.1853 24.0027C23.4347 24.0027 23.6845 23.9074 23.8751 23.7169C24.2562 23.3361 24.2562 22.7182 23.8751 22.3374Z" fill="white"/>-->
<!--                        </svg>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="search-modal__result" >-->
<!--                    <div class="search-modal__result-headline">תוצאות חיפוש</div>-->
<!--                    <div class="search-modal__result-goods">-->
<!--                        <a :href="prod.url" v-for="(prod, idx) in prods" :key="idx" class="search-modal__result-item">-->
<!--                          <div class="search-view-image">-->
<!--                            <img :src="prod.image" alt="">-->
<!--                          </div>-->
<!--                          <div class="search-modal__result-item__name">-->
<!--                            {{ prod.name }}-->
<!--                          </div>-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </transition>-->
<!--    </teleport>-->
<!--</template>-->

<!--<script>-->

<!--import placeholder from "lodash/fp/placeholder";-->

<!--export default {-->
<!--  name: 'Search',-->
<!--  components: {},-->
<!--  props: {},-->
<!--  data() {-->
<!--    return {-->
<!--      text: "",-->
<!--      isOpen: false,-->
<!--      placeholder: "חפש מוצרים וקבוצות מוצרים",-->
<!--      prods: [],-->
<!--    }-->
<!--  },-->
<!--  mounted() {-->
<!--    // onClose(this.$options.name, () => { this.isOpen = false});-->
<!--  },-->
<!--  methods: {-->
<!--    onTextChanged(){-->
<!--      axios.get(route(`client.product.search`), {params: {-->
<!--          text : this.text-->
<!--        }}).then((resp) => {-->
<!--        this.prods = [-->
<!--          ...resp.data.items-->
<!--        ]-->
<!--      })-->
<!--    },-->
<!--    toggle() {-->
<!--      this.isOpen = !this.isOpen-->
<!--      if (this.isOpen) {-->
<!--        document.querySelector('body').classList.add('search-open')-->
<!--        //close(this.$options.name);-->
<!--        this.$nextTick(function (){-->
<!--          this.$refs.searchInput.focus()-->
<!--        })-->
<!--      } else {-->
<!--        document.querySelector('body').classList.remove('search-open')-->
<!--      }-->
<!--    },-->
<!--    onClickChild(value) {-->
<!--      this.component = value;-->
<!--    },-->
<!--    handleFocus() {-->
<!--      // do something here-->
<!--    },-->
<!--    handleFocusOut() {-->
<!--      alert('clicked')-->
<!--      this.isOpen = !this.isOpen-->
<!--      if (this.isOpen) {-->
<!--        document.querySelector('body').classList.add('search-open')-->
<!--        //close(this.$options.name);-->
<!--      } else {-->
<!--        document.querySelector('body').classList.remove('search-open')-->
<!--      }-->
<!--    },-->
<!--    onSearch(){-->
<!--      window.coolSearch(this.text)-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<template>
  <span class="input-container">
    <input
      class="search-input"
      ref="searchInput"
      type="text"
      v-model="text"
      @input="onTextChanged"
      @keypress.enter="onSearch"
      @blur = "placeholder = 'חפש מוצרים וקבוצות מוצרים'"
      @focus = "placeholder = 'חפש מוצרים וקבוצות מוצרים'"
      :placeholder="placeholder"
    >

    <span class="search-icon">
      <svg width="16" height="16" viewBox="0 0 25 25" fill="black" xmlns="http://www.w3.org/2000/svg">--}}
        <path d="M10.7297 0.00280762C4.90209 0.00280762 0.160645 4.74426 0.160645 10.5719C0.160645 16.3999 4.90209 21.141 10.7297 21.141C16.5577 21.141 21.2988 16.3999 21.2988 10.5719C21.2988 4.74426 16.5577 0.00280762 10.7297 0.00280762ZM10.7297 19.1898C5.97787 19.1898 2.11186 15.3238 2.11186 10.5719C2.11186 5.82009 5.97787 1.95402 10.7297 1.95402C15.4816 1.95402 19.3476 5.82004 19.3476 10.5719C19.3476 15.3237 15.4816 19.1898 10.7297 19.1898Z"
          fill="black"/>
        <path d="M23.8751 22.3374L18.2816 16.7439C17.9005 16.3627 17.2832 16.3627 16.9021 16.7439C16.5209 17.1247 16.5209 17.7426 16.9021 18.1234L22.4956 23.7169C22.6861 23.9074 22.9356 24.0027 23.1853 24.0027C23.4347 24.0027 23.6845 23.9074 23.8751 23.7169C24.2562 23.3361 24.2562 22.7182 23.8751 22.3374Z"
          fill="black"/>
      </svg>
    </span>

    <span class="close-icon hide" @click="toggle">
      <svg width="12" height="12" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9375 9.99995L19.7943 2.21211C20.3056 1.70554 20.3056 0.886492 19.7943 0.379925C19.2833 -0.126642 18.4569 -0.126642 17.9459 0.379925L10.0888 8.16777L2.23195 0.379925C1.72064 -0.126642 0.894552 -0.126642 0.383482 0.379925C-0.127827 0.886492 -0.127827 1.70554 0.383482 2.21211L8.24031 9.99995L0.383482 17.7878C-0.127827 18.2944 -0.127827 19.1134 0.383482 19.62C0.638179 19.8727 0.973067 19.9996 1.30772 19.9996C1.64237 19.9996 1.97701 19.8727 2.23195 19.62L10.0888 11.8321L17.9459 19.62C18.2008 19.8727 18.5354 19.9996 18.8701 19.9996C19.2047 19.9996 19.5394 19.8727 19.7943 19.62C20.3056 19.1134 20.3056 18.2944 19.7943 17.7878L11.9375 9.99995Z"
              fill="black"/>
        </svg>
    </span>
  </span>

  <teleport to="#search-field">
    <transition name="fade">
      <div v-if="isOpen" class="search-modal__wrapper hide">
<!--        <div class="search-modal">-->
<!--          <input ref="searchInput" type="text" v-model="text" @input="onTextChanged" @keypress.enter="onSearch" aria-label="תוצאות חיפוש">-->
<!--          <div class="search-modal__close" @click="toggle">-->
<!--            <svg width="21" height="20" viewBox="0 0 21 20" fill="none"-->
<!--                 xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M11.9375 9.99995L19.7943 2.21211C20.3056 1.70554 20.3056 0.886492 19.7943 0.379925C19.2833 -0.126642 18.4569 -0.126642 17.9459 0.379925L10.0888 8.16777L2.23195 0.379925C1.72064 -0.126642 0.894552 -0.126642 0.383482 0.379925C-0.127827 0.886492 -0.127827 1.70554 0.383482 2.21211L8.24031 9.99995L0.383482 17.7878C-0.127827 18.2944 -0.127827 19.1134 0.383482 19.62C0.638179 19.8727 0.973067 19.9996 1.30772 19.9996C1.64237 19.9996 1.97701 19.8727 2.23195 19.62L10.0888 11.8321L17.9459 19.62C18.2008 19.8727 18.5354 19.9996 18.8701 19.9996C19.2047 19.9996 19.5394 19.8727 19.7943 19.62C20.3056 19.1134 20.3056 18.2944 19.7943 17.7878L11.9375 9.99995Z"-->
<!--                    fill="#FFFFFF"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div class="search-modal__btn" @click="onSearch">-->
<!--            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M10.7297 0.00280762C4.90209 0.00280762 0.160645 4.74426 0.160645 10.5719C0.160645 16.3999 4.90209 21.141 10.7297 21.141C16.5577 21.141 21.2988 16.3999 21.2988 10.5719C21.2988 4.74426 16.5577 0.00280762 10.7297 0.00280762ZM10.7297 19.1898C5.97787 19.1898 2.11186 15.3238 2.11186 10.5719C2.11186 5.82009 5.97787 1.95402 10.7297 1.95402C15.4816 1.95402 19.3476 5.82004 19.3476 10.5719C19.3476 15.3237 15.4816 19.1898 10.7297 19.1898Z" fill="white"/>-->
<!--              <path d="M23.8751 22.3374L18.2816 16.7439C17.9005 16.3627 17.2832 16.3627 16.9021 16.7439C16.5209 17.1247 16.5209 17.7426 16.9021 18.1234L22.4956 23.7169C22.6861 23.9074 22.9356 24.0027 23.1853 24.0027C23.4347 24.0027 23.6845 23.9074 23.8751 23.7169C24.2562 23.3361 24.2562 22.7182 23.8751 22.3374Z" fill="white"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--        </div>-->
        <div class="search-modal__result" >
          <div class="search-modal__result-headline">תוצאות חיפוש</div>
          <div class="search-modal__result-goods">
            <a :href="prod.url" v-for="(prod, idx) in prods" :key="idx" class="search-modal__result-item">
              <div class="search-view-image">
                <img :src="prod.image" alt="">
              </div>
              <div class="search-modal__result-item__name">
                {{ prod.name }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>

    //import placeholder from "lodash/fp/placeholder";

    export default {
        name: 'Search',
        components: {},
        props: {},
        data() {
            return {
                text: "",
                isOpen: false,
                placeholder: "חפש מוצרים וקבוצות מוצרים",
                prods: [],
            }
        },
        mounted() {
            // onClose(this.$options.name, () => { this.isOpen = false});
        },
        methods: {
          onTextChanged(){
            if (this.text.length > 0) {
              var closeIcon = document.querySelector('.close-icon.hide');
              if (closeIcon) {
                console.log("Open")
                this.isOpen = !this.isOpen
                document.querySelector('.close-icon.hide').classList.remove('hide')
              }
            }
            else {
              this.isOpen = !this.isOpen
              document.querySelector('.close-icon').classList.add('hide')
            }

            axios.get(route(`client.product.search`), {params: {
                text : this.text
              }}).then((resp) => {
              this.prods = [
                ...resp.data.items
              ]
            })
          },
            toggle() {
                // this.isOpen = !this.isOpen
                // if (this.isOpen) {
                //     document.querySelector('body').classList.add('search-open')
                //     //close(this.$options.name);
                //   this.$nextTick(function (){
                //     this.$refs.searchInput.focus()
                //   })
                // } else {
                //     document.querySelector('body').classList.remove('search-open')
                // }
                this.text = "";
                this.onTextChanged();
            },
            onClickChild(value) {
                this.component = value;
            },
            handleFocus() {
                // do something here
            },
            handleFocusOut() {
                // alert('clicked')
                // this.isOpen = !this.isOpen
                // if (this.isOpen) {
                //     document.querySelector('body').classList.add('search-open')
                //     //close(this.$options.name);
                // } else {
                //     document.querySelector('body').classList.remove('search-open')
                // }
            },
          onSearch(){
            window.coolSearch(this.text)
          }
        }
    }
</script>

<style lang="scss" scoped>


</style>




